<template>
  <div class="content">
    <!--<h1 class="has-text-centered">AHL Calendar</h1>-->
    <header-component
        :selected-state="selectedState"
        :selected-region="selectedRegion"
        :hosts="hosts"
        :selectedStyle="style"
        :selected-host="selectedHost"
        :user="user"
        @setDate="setDate"
        @getCalendar="getCalendar"
        @switchStyle="switchStyle"
        @setRegion="setRegion"
        @setCity="setCity"
        @selectHost="selectHost"
    />
    <div
        v-if="!show"
        class="spinner-loader"
    >
      <sync-loader/>
      <p>Loading ...</p>
    </div>
    <div
        v-if="show && isEmptyCalendar"
        class="has-text-centered block-content"
    >
      <h5 class="subtitle is-5">
        There are not any games in this region. Please back check later.
      </h5>
      <img
          src="/images/dps.png"
          width="280"
      >
    </div>
    <component
        :is="style"
        v-if="show"
        :data="data"
        :region="selectedRegion"
        :style="style"
        :fetched-hosts="fetchedHosts"
        :user="user"
        :token="token"
        :hosts="hosts"
        :filtered-host="selectedHost"
        :set-host-date="setHostDate"
        @setHost="setHost"
        @makeDefault="makeDefault"
    />
  </div>
</template>

<script>
import Today from './Today.vue'
import List from './List.vue'
import Calendar from './Whole.vue'
import HeaderComponent from './header/Index.vue'

import axios from 'axios'

export default {
  name: 'CalendarMain',
  metaInfo: {
    title: 'AHL Poker :: Calendar'
  },
  components: {
    Today,
    List,
    Calendar,
    HeaderComponent
  },
  props: ['user', 'token', 'region', 'selRegion', 'regionList'],
  data() {
    return {
      date: new Date(),
      data: '',
      hosts: [],
      fetchedHosts: [],
      city: '',
      style: 'today',
      selectedState: {
        name: 'TX',
        regions: [
          {
            regionId: 732,
            name: '732: AHL Dallas'
          },
          {
            regionId: 733,
            name: '733: AHL Midcities'
          },
        ]
      },
      selectedRegion: 732,
      show: false,
      setHostDate: '',
      selectedHost: 'Select Host'
    }
  },
  computed: {
    searchDate() {
      let now = new Date(this.date)
      let year = now.getFullYear()
      let month = now.getMonth()
      let day = now.getDate()
      // Date for set host
      this.setHostDate = `${this.getMonth(month)}_${day}_${year}`
      // Date for search
      return (`${year}-${month + 1}-${day}`)
    },
    isEmptyCalendar() {
      let check = this.data.find((day) => {
        return day.venues.length > 0
      })
      if (!check) return true
      return false
    }
  },
  watch: {
    regionList() {
      this.setRegions()
    }
  },
  mounted() {
    if (this.$route.params.state) {
      this.selectedState = this.$route.params.state
    }

    if (this.$route.params.selectedRegion) {
      this.selectedRegion = this.$route.params.selectedRegion
    } else if (this.region) {
      this.selectedRegion = this.region
    }

    if (this.$route.params.city) {
      this.city = this.$route.params.city
    }
    if (this.$route.params.style) {
      this.style = this.$route.params.style
    }
    if (this.regionList) this.setRegions()
    // Set current day and month
    this.getCalendar()
  },
  methods: {
    selectHost(name) {
      this.selectedHost = name
    },
    getCalendar() {
      this.show = false
      let style = this.style
      let region, url
      let token = ''
      if (this.token) {
        token = this.token
      }
      if (this.city) {
        region = this.city
      } else {
        region = this.selectedRegion
      }

      if (style === 'today' || 'list') {
        url = `calendar/get/${style}/${region}/${this.searchDate}`
      } else url = `calendar/get/${style}/${region}`
      this.$axios({
        method: 'POST',
        url: url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: token
        }
      })
          .then((res) => {
            this.data = res.data.days
            this.selectedRegion = res.data.region;
            this.fetchedHosts = res.data.hosts
            this.getHosts(res.data.days)
            this.city = ''
            this.show = true
          })
          .catch((error) => {
            console.log(error)
          })
    },
    getHosts(data) {
      this.hosts = []
      data.forEach(item => {
        item.venues.forEach(v => {
          if (v.stime1_host && !this.hosts.find(h => h === v.stime1_host.name)) this.hosts.push(v.stime1_host.name)
        })
      })
      this.hosts.sort()
      this.hosts.unshift('Select Host')
    },
    setDate(date) {
      this.date = date
    },
    switchStyle(style) {
      this.style = style
      this.getCalendar(false)
      this.$router.push(`/calendar/${style}`)
    },
    getCurrentMonth() {
      let date = new Date()
      return date.getMonth()
    },
    getMonth(number) {
      // Number is month 0 - Jan, 1 - Feb, etc. If current month is Nov or Dec turn to Jun and Feb
      if (number === 12) {
        number = 0
      }
      if (number === 13) {
        number = 1
      }
      switch (number) {
        case 0:
          return 'Jan'
        case 1:
          return 'Feb'
        case 2:
          return 'Mar'
        case 3:
          return 'Apr'
        case 4:
          return 'May'
        case 5:
          return 'Jun'
        case 6:
          return 'Jul'
        case 7:
          return 'Aug'
        case 8:
          return 'Sep'
        case 9:
          return 'Oct'
        case 10:
          return 'Nov'
        case 11:
          return 'Dec'
        default:
          return 'Error'
      }
    },
    getDaysInCurrentMonth() {
      let date = new Date()
      let month = date.getMonth()
      let year = date.getFullYear()
      return new Date(year, month + 1, 0).getDate()
    },
    setCity(city) {
      this.city = city
    },
    setRegion(region) {
      this.selectedRegion = region
      //this.$router.push(`/calendar/${region}/${this.style}`)
      this.getCalendar(false)
    },
    convertDate(date) {
      let arr = date.split('-')
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${months[arr[1] - 1]}_${arr[2]}_${arr[0]}`
    },
    setHost(date, session, venueId, hostId, gameDate) {
      if (!session) {
        session = 1
      }
      let url
      if (typeof gameDate !== 'string') {
        url = `calendar/set/${this.convertDate(date)}_${venueId}_${session}/${hostId}`
      } else url = `calendar/set/${this.convertDate(date)}_${venueId}_${gameDate}_${session}/${hostId}`
      this.$axios({
        method: 'POST',
        url: url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.token
        }
      })
          .then((res) => {
            this.getCalendar(false)
            this.$emit('message',
                {
                  showDialog: true,
                  error: false,
                  message: res.data.message
                })
          })
          .catch((error) => {
            console.log(error)
            this.$emit('message',
                {
                  showDialog: true,
                  error: true,
                  message: error.response.data.message
                })
          })
    },
    makeDefault(calId, session, venueId, hostId) {
      if (!session) {
        session = 1
      }
      let url = `calendar/setDefault/${calId}/${venueId}/${session}/${hostId}`
      this.$axios({
        method: 'POST',
        url: url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.token
        }
      })
          .then((res) => {
            this.getCalendar(false)
            this.$emit('message',
                {
                  showDialog: true,
                  error: false,
                  message: res.data.message
                })
          })
          .catch((error) => {
            console.log(error)
            this.$emit('message',
                {
                  showDialog: true,
                  error: true,
                  message: error.response.data.message
                })
          })
    },
    setRegions() {
      this.selectedState.regions = this.regionList;
    }
  }
}
</script>
